
import React from 'react'
import icon from './svgs/lock.svg'
import { BaseIcon } from './_base'

export const LockIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
